<template>
    <div class="ds-schedule-toolbar ds-app-shell relative z-50">
        <div class="ds-schedule-toolbar-left">
            <div>
                <DepartmentsTree class="ds-schedule-store-selector z-40" />
            </div>
            <div class="ds-schedule-month-nav relative">
                <button type="button" class="ds-schedule-month-arrow" @click="scheduleStore.prevScheduleMonth()">
                    <icon width="9" height="13"><IconChevronLeft /></icon>
                </button>
                <div
                    class="ds-schedule-month-control ds-schedule-month-trigger"
                    @click="isMonthPickerOpen = true"
                >
                    {{ currentMonth }}
                </div>
                <button type="button" class="ds-schedule-month-arrow" @click="scheduleStore.nextScheduleMonth()">
                    <icon width="9" height="13"><IconChevronRight /></icon>
                </button>
                <div v-if="isMonthPickerOpen" class="fixed inset-0 z-40" @click="isMonthPickerOpen = false" />
                <div v-if="isMonthPickerOpen" class="schedule-month-picker absolute top-full mt-1 left-1/2 -translate-x-1/2 z-50 rounded-xl p-4 w-48">
                    <AppCalendar
                        :model-value="scheduleStore.currentScheduleDate"
                        precision="month"
                        @update:model-value="onMonthSelect"
                    />
                </div>
            </div>
        </div>
        <div class="ds-schedule-toolbar-right ml-auto">
            <div class="ds-schedule-mode-switcher relative -top-0.5 flex h-6 items-center gap-2">
                <span>График</span>
                <BooleanSwitch
                    class="!gap-0"
                    :model-value="isTimesheetMode"
                    @update:model-value="onSwitch"
                />
                <span>Табель</span>
            </div>
            <div class="px-[7px]">
                <SmallTooltip text="Автосоставление">
                    <button-icon @click="onScheduleGen">
                        <IconStar />
                        <template v-slot:hover>
                            <IconStarColor />
                        </template>
                    </button-icon>
                </SmallTooltip>
            </div>
            <div class="px-[7px]">
                <SmallTooltip text="Режим отметок">
                    <button-icon class="text-gray" @click="isUrvOverlayOpen = true">
                        <IconQr />
                        <template v-slot:hover>
                            <IconQrColor />
                        </template>
                    </button-icon>
                </SmallTooltip>
            </div>
            <div class="px-[7px] relative z-10">
                <toggle ref="optionsMenu">
                    <template v-slot:trigger>
                        <button-icon>
                            <IconOptions />
                            <template v-slot:hover>
                                <IconOptionsColor />
                            </template>
                        </button-icon>
                    </template>
                    <div class="min-w-60 px-2 py-2">
                        <button v-if="authStore.permissions?.can_download_timesheet" class="ds-header-user-menu-item" type="button" @click="getTimesheetReport">
                            Скачать табель
                        </button>
                        <button v-if="authStore.permissions?.can_download_schedule" class="ds-header-user-menu-item" type="button" @click="getScheduleReport">
                            Скачать график
                        </button>
                        <button v-if="authStore.permissions?.can_download_work_time_report" class="ds-header-user-menu-item" type="button" @click="getConsReport">
                            Скачать отчет
                        </button>
                        <button v-if="authStore.permissions?.can_download_fraud_report" class="ds-header-user-menu-item" type="button" @click="getFraudReport">
                            Скачать отчет о фроде
                        </button>
                        <button v-if="authStore.permissions?.can_download_discipline_report" class="ds-header-user-menu-item" type="button" @click="getDisciplineReport">
                            Скачать отчет о дисциплине
                        </button>
                        <button v-if="authStore.permissions?.can_download_manual_marks_report" class="ds-header-user-menu-item" type="button" @click="getManualMarksReport">
                            Скачать отчёт об отметках
                        </button>
                        <div class="ds-schedule-toolbar-menu-divider" aria-hidden="true"></div>
                        <button class="ds-header-user-menu-item" type="button" @click="copySchedule">
                            Скопировать график на месяц
                        </button>
                        <button class="ds-header-user-menu-item" type="button" @click="cleanSchedule">
                            Очистить график
                        </button>
                      <div class="ds-schedule-toolbar-menu-divider" aria-hidden="true"></div>
                      <button class="ds-header-user-menu-item" type="button"
                            @click="departmentSettings">
                            Настройки магазина
                        </button>
                      <div class="ds-schedule-toolbar-menu-divider" aria-hidden="true"></div>
                      <div
                            class="ds-header-user-menu-item ds-header-user-menu-item-with-control"
                            role="menuitemcheckbox"
                            :aria-checked="isGridVisible"
                            tabindex="0"
                            @click="toggleGridVisible"
                            @keydown.enter.prevent="toggleGridVisible"
                            @keydown.space.prevent="toggleGridVisible"
                        >
                            <span>Показать сетку</span>
                            <checkbox
                                :model-value="isGridVisible"
                                size="sm"
                                layout="inline"
                                @update:model-value="isGridVisible = $event"
                                @click.stop
                            />
                        </div>
                        <div
                            class="ds-header-user-menu-item ds-header-user-menu-item-with-control"
                            role="menuitemcheckbox"
                            :aria-checked="scheduleStore.isLightTheme"
                            tabindex="0"
                            @click="scheduleStore.isLightTheme = !scheduleStore.isLightTheme"
                            @keydown.enter.prevent="scheduleStore.isLightTheme = !scheduleStore.isLightTheme"
                            @keydown.space.prevent="scheduleStore.isLightTheme = !scheduleStore.isLightTheme"
                        >
                            <span>Светлая тема</span>
                            <checkbox
                                :model-value="scheduleStore.isLightTheme"
                                size="sm"
                                layout="inline"
                                @update:model-value="scheduleStore.isLightTheme = $event"
                                @click.stop
                            />
                        </div>
                        <div
                            class="ds-header-user-menu-item ds-header-user-menu-item-with-control"
                            role="menuitemcheckbox"
                            :aria-checked="scheduleStore.isDayStatsVisible"
                            tabindex="0"
                            @click="scheduleStore.isDayStatsVisible = !scheduleStore.isDayStatsVisible"
                            @keydown.enter.prevent="scheduleStore.isDayStatsVisible = !scheduleStore.isDayStatsVisible"
                            @keydown.space.prevent="scheduleStore.isDayStatsVisible = !scheduleStore.isDayStatsVisible"
                        >
                            <span>Дневные показатели</span>
                            <checkbox :model-value="scheduleStore.isDayStatsVisible" size="sm" layout="inline" @update:model-value="scheduleStore.isDayStatsVisible = $event" @click.stop />
                        </div>
                        <div
                            class="ds-header-user-menu-item ds-header-user-menu-item-with-control"
                            role="menuitemcheckbox"
                            :aria-checked="scheduleStore.isEmployeeStatsVisible"
                            tabindex="0"
                            @click="scheduleStore.isEmployeeStatsVisible = !scheduleStore.isEmployeeStatsVisible"
                            @keydown.enter.prevent="scheduleStore.isEmployeeStatsVisible = !scheduleStore.isEmployeeStatsVisible"
                            @keydown.space.prevent="scheduleStore.isEmployeeStatsVisible = !scheduleStore.isEmployeeStatsVisible"
                        >
                            <span>Показатели сотрудника</span>
                            <checkbox :model-value="scheduleStore.isEmployeeStatsVisible" size="sm" layout="inline" @update:model-value="scheduleStore.isEmployeeStatsVisible = $event" @click.stop />
                        </div>
                        <div
                            class="ds-header-user-menu-item ds-header-user-menu-item-with-control"
                            role="menuitemcheckbox"
                            :aria-checked="scheduleStore.isCellHighlighting"
                            tabindex="0"
                            @click="scheduleStore.isCellHighlighting = !scheduleStore.isCellHighlighting"
                            @keydown.enter.prevent="scheduleStore.isCellHighlighting = !scheduleStore.isCellHighlighting"
                            @keydown.space.prevent="scheduleStore.isCellHighlighting = !scheduleStore.isCellHighlighting"
                        >
                            <span>Выделение ячеек</span>
                            <checkbox
                                :model-value="scheduleStore.isCellHighlighting"
                                size="sm"
                                layout="inline"
                                @update:model-value="scheduleStore.isCellHighlighting = $event"
                                @click.stop
                            />
                        </div>
                    </div>
                </toggle>
            </div>
        </div>

    </div>

    <Teleport to="body">
        <SidePanel ref="copyPanel">
            <MonthShiftsCopy @copied="closeCopyPanel" />
        </SidePanel>

        <SidePanel ref="cleanPanel">
            <MonthShiftsClean @close="cleanSchedule" />
        </SidePanel>

        <SidePanel ref="depSettings">
            <DepartmentSettings />
        </SidePanel>
    </Teleport>

    <modal v-if="showModal" @close="closeModal()">
        <div class="text-xl px-3 mb-5">Сгенерировать расписание на месяц?</div>
        <div class="flex justify-end">
            <btn class="px-5 mx-3" @click="genSchedule()" :disabled="isDisabled" :class="{ 'opacity-50': isDisabled }">
                Да
            </btn>
            <btn class="px-5" type="secondary" @click="closeModal()">Нет</btn>
        </div>
    </modal>

    <ReportDownloadModal
        v-if="reportModal"
        :title="reportModal.title"
        :report-fn="reportModal.reportFn"
        :report-name="reportModal.reportName"
        :initial-date="scheduleStore.currentScheduleDate"
        :readonly="reportModal.readonly"
        :is-consolidated="reportModal.isConsolidated"
        @close="reportModal = null"
    />

    <UrvOverlay
        v-if="isUrvOverlayOpen"
        @close="isUrvOverlayOpen = false"
    />

</template>

<script setup lang="ts">
import IconOptions from '../../ui/icons/IconOptions.vue'
// import IconDiagram from '../../ui/icons/IconDiagram.vue'
import IconStar from '../../ui/icons/IconStar.vue'
import IconChevronLeft from '../../ui/icons/IconChevronLeft.vue'
import IconChevronRight from '../../ui/icons/IconChevronRight.vue'
import IconQr from '../../ui/icons/IconQr.vue'
import IconQrColor from '../../ui/icons/IconQrColor.vue'
import AppCalendar from '@/ui/AppCalendar.vue'
import BooleanSwitch from '@/ui/BooleanSwitch.vue'
// import IconDiagramColor from '../../ui/icons/IconDiagramColor.vue'
import IconStarColor from '../../ui/icons/IconStarColor.vue'
import IconOptionsColor from '../../ui/icons/IconOptionsColor.vue'
import DepartmentsTree from './DepartmentsTree.vue'
import SidePanel from '../schedule/SidePanel.vue'
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import type { Dayjs } from 'dayjs'
import MonthShiftsCopy from '../schedule/MonthShiftsCopy.vue'
import MonthShiftsClean from '../schedule/MonthShiftsClean.vue'
import dayjs from 'dayjs'
import { useToast } from 'vue-toast-notification'
import DepartmentSettings from './DepartmentSettings.vue'
import UrvOverlay from '@/components/urv/UrvOverlay.vue'
import { useScheduleStore } from '@/stores/scheduleStore'
import { useDepartmentStore } from '@/stores/departmentStore'
import { useAuthStore } from '@/stores/authStore'
import ReportDownloadModal from '@/ui/ReportDownloadModal.vue'
import SmallTooltip from '@/components/SmallTooltip.vue'
import {
    getTimesheetReport as timesheetApi,
    getScheduleReport as scheduleApi,
    getConsolidatedReport as consApi,
    getDisciplineReport as disciplineApi,
    getFraudReport as fraudApi,
    getManualMarksReport as manualMarksApi,
} from '@/api/schedule'

const authStore = useAuthStore()
const departmentStore = useDepartmentStore()
const scheduleStore = useScheduleStore()
const toast = useToast({ position: 'top' })

const emit = defineEmits(['switch'])

const isMonthPickerOpen = ref(false)
const isTimesheetMode = ref(false)
const isUrvOverlayOpen = ref(false)
const scheduleGridStorageKey = 'main-front:schedule-grid-visible'
const lightThemeStorageKey = 'main-front:schedule-light-theme'
const cellHighlightingStorageKey = 'main-front:schedule-cell-highlighting'
const dayStatsStorageKey = 'main-front:schedule-day-stats-visible'
const employeeStatsStorageKey = 'main-front:schedule-employee-stats-visible'
const isGridVisible = ref(false)
const currentMonth = computed(() => scheduleStore.currentScheduleDate.format('MMMM YYYY'))

const toggleGridVisible = () => {
    isGridVisible.value = !isGridVisible.value
}

function onMonthSelect(value: Dayjs | [Dayjs, Dayjs] | Dayjs[]) {
    const d = value as Dayjs
    scheduleStore.goToMonth(d.year(), d.month())
    isMonthPickerOpen.value = false
}

const copyPanel = ref()
const cleanPanel = ref()
const depSettings = ref()
const optionsMenu = ref<{ close: (immediately?: boolean) => void }>()
const showModal = ref<Boolean>(false)
const reportModal = ref<{
    title: string
    reportFn: (data: any) => Promise<any>
    reportName: string
    readonly?: boolean
    isConsolidated?: boolean
} | null>(null)
const isDisabled = computed(() => dayjs().isAfter(scheduleStore.currentScheduleDate.startOf('month')))

const closeCopyPanel = () => {
    copyPanel.value?.close()
}

function closeModal() {
    showModal.value = false
}

const onSwitch = (isTimesheet: boolean) => {
    isTimesheetMode.value = isTimesheet
    emit('switch', !isTimesheet)
}

const getTimesheetReport = () => {
    openReport({ title: 'Скачать табель', reportFn: timesheetApi, reportName: 'Табель работы сотрудников' })
}
const getScheduleReport = () => {
    openReport({ title: 'Скачать график', reportFn: scheduleApi, reportName: 'График работы сотрудников', readonly: true })
}
const getConsReport = () => {
    openReport({
        title: 'Скачать отчет',
        reportFn: consApi,
        reportName: 'Консолидированный отчет',
        isConsolidated: true,
    })
}
const getFraudReport = () => {
    openReport({ title: 'Скачать отчет о фроде', reportFn: fraudApi, reportName: 'Отчет о фроде' })
}
const getDisciplineReport = () => {
    openReport({ title: 'Скачать отчет о дисциплине', reportFn: disciplineApi, reportName: 'Отчет о дисциплине' })
}
const getManualMarksReport = () => {
    openReport({
        title: 'Скачать отчёт об отметках',
        reportFn: manualMarksApi,
        reportName: 'Отчёт об отметках',
    })
}

function openReport(report: NonNullable<typeof reportModal.value>) {
    optionsMenu.value?.close(true)
    reportModal.value = report
}

const copySchedule = async () => {
    if(authStore.permissions?.can_create_schedule) {
        copyPanel.value.toggle()
    } else {
        toast.error('У вас нет прав на данное действие')
    }
}

const cleanSchedule = async () => {
    if(authStore.permissions?.can_create_schedule) {
        cleanPanel.value.toggle()
    } else {
        toast.error('У вас нет прав на данное действие')
    }
}

const genSchedule = async () => {
    scheduleStore.scheduleGenerate()
    closeModal()
}

const onScheduleGen = () => {
    if (isDisabled.value) {
        toast.error('Нельзя составить график на прошедший или текущий месяц')
    }
    else if (!authStore.permissions?.can_create_schedule) {
        toast.error('У вас нет прав на создание расписания')
    }
    else {
        showModal.value = true
    }
}

const departmentSettings = () => {
    depSettings.value.toggle()
}

onMounted(async () => {
    isGridVisible.value = localStorage.getItem(scheduleGridStorageKey) === 'true'
    localStorage.setItem(scheduleGridStorageKey, String(isGridVisible.value))
    const savedLightTheme = localStorage.getItem(lightThemeStorageKey)
    const savedCellHighlighting = localStorage.getItem(cellHighlightingStorageKey)
    const savedDayStats = localStorage.getItem(dayStatsStorageKey)
    const savedEmployeeStats = localStorage.getItem(employeeStatsStorageKey)
    scheduleStore.isLightTheme = savedLightTheme === null ? false : savedLightTheme === 'true'
    scheduleStore.isCellHighlighting = savedCellHighlighting === null ? false : savedCellHighlighting === 'true'
    scheduleStore.isDayStatsVisible = savedDayStats === null ? true : savedDayStats === 'true'
    scheduleStore.isEmployeeStatsVisible = savedEmployeeStats === null ? true : savedEmployeeStats === 'true'
    localStorage.setItem(lightThemeStorageKey, String(scheduleStore.isLightTheme))
    localStorage.setItem(cellHighlightingStorageKey, String(scheduleStore.isCellHighlighting))
    localStorage.setItem(dayStatsStorageKey, String(scheduleStore.isDayStatsVisible))
    localStorage.setItem(employeeStatsStorageKey, String(scheduleStore.isEmployeeStatsVisible))
    document.documentElement.classList.toggle('schedule-grid-enabled', isGridVisible.value)
    await departmentStore.fetchAllDepartments()
})

onUnmounted(() => {
    document.documentElement.classList.remove('schedule-grid-enabled')
})

watch(isGridVisible, (value) => {
    localStorage.setItem(scheduleGridStorageKey, String(value))
    document.documentElement.classList.toggle('schedule-grid-enabled', value)
})

watch(() => scheduleStore.isLightTheme, (value) => {
    localStorage.setItem(lightThemeStorageKey, String(value))
})

watch(() => scheduleStore.isCellHighlighting, (value) => {
    localStorage.setItem(cellHighlightingStorageKey, String(value))
})

watch(() => scheduleStore.isDayStatsVisible, (value) => {
    localStorage.setItem(dayStatsStorageKey, String(value))
})

watch(() => scheduleStore.isEmployeeStatsVisible, (value) => {
    localStorage.setItem(employeeStatsStorageKey, String(value))
})

</script>

<style scoped>
.schedule-month-picker {
    border: 1px solid rgb(255 255 255 / 0.58);
    background: rgb(255 255 255 / 0.72);
    box-shadow: 0 4px 12px oklch(0% 0 0 / 0.1);
    -webkit-backdrop-filter: blur(8px);
    backdrop-filter: blur(8px);
}
</style>
